/**
 * @copyright 2019 @ DigiNet
 * @author rocachien
 * @create 2019/02/21 08:57
 * @update 2019/02/21 08:57
 */

import * as types from '../actions/types.js';

const initialState = {
    dataDebtMethod:null
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W18_W18F4050_DATADEBTMETHOD_COMPLETE:
            return {
                ...state,
                dataDebtMethod: action.dataDebtMethod
            };

        default:
            return state;
    }
}